import { render, staticRenderFns } from "./RelatedProduct.vue?vue&type=template&id=63e5976b&scoped=true&lang=html"
import script from "./RelatedProduct.vue?vue&type=script&lang=js"
export * from "./RelatedProduct.vue?vue&type=script&lang=js"
import style0 from "./RelatedProduct.vue?vue&type=style&index=0&id=63e5976b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e5976b",
  null
  
)

export default component.exports